import { jsxs, jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { cn } from "../../../lib/utils.js";
import { useQuizStyleVariant } from "./quiz-style-context.js";
import { motion } from "../../../node_modules/.pnpm/framer-motion@11.18.2_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/framer-motion/dist/es/render/components/motion/proxy.js";
function QuizResultToggle({ value, onChange, disabled = false }) {
  const { t } = useTranslation("quiz");
  const variant = useQuizStyleVariant();
  if (variant === "lc") {
    const checked = value === "correct-and-explanation";
    return /* @__PURE__ */ jsxs(
      motion.div,
      {
        initial: { opacity: 0, y: 8 },
        animate: { opacity: 1, y: 0 },
        transition: { duration: 0.25 },
        className: "flex items-center gap-2 overflow-hidden pt-2",
        children: [
          /* @__PURE__ */ jsx("span", { className: "text-[16px] font-medium leading-none tracking-[0.2px] text-lc-text-secondary", children: t("toggle.correctAndExplanation") }),
          /* @__PURE__ */ jsx(
            "button",
            {
              type: "button",
              role: "switch",
              "aria-label": t("toggle.correctAndExplanation"),
              "aria-checked": checked,
              disabled,
              onClick: () => {
                if (!disabled) {
                  onChange(checked ? "my-answer" : "correct-and-explanation");
                }
              },
              className: cn(
                "relative inline-flex h-6 w-12 shrink-0 items-center rounded-full px-[3px] transition-colors",
                checked ? "bg-lc-success-500" : "bg-lc-v3-gray-300",
                disabled && "cursor-not-allowed opacity-60"
              ),
              children: /* @__PURE__ */ jsx(
                "span",
                {
                  "aria-hidden": true,
                  className: cn(
                    "size-[18px] rounded-full bg-white shadow-[0_1.5px_0_0_rgb(0_0_0/0.1)] transition-transform",
                    checked && "translate-x-6"
                  )
                }
              )
            }
          )
        ]
      }
    );
  }
  const segment = (segValue, label, activeBg) => {
    const active = value === segValue;
    return /* @__PURE__ */ jsx(
      "button",
      {
        type: "button",
        role: "button",
        "aria-pressed": active,
        disabled,
        onClick: () => !disabled && onChange(segValue),
        className: cn(
          "h-8 px-5 rounded-full text-sm font-bold tracking-[-0.6px] transition-all duration-200",
          active ? `${activeBg} text-white` : "bg-transparent text-lc-gray-500",
          disabled && "cursor-not-allowed"
        ),
        children: label
      }
    );
  };
  return /* @__PURE__ */ jsxs(
    motion.div,
    {
      initial: { opacity: 0, y: 8 },
      animate: { opacity: 1, y: 0 },
      transition: { duration: 0.25 },
      className: cn(
        "inline-flex p-1 rounded-full",
        disabled ? "bg-lc-gray-400" : "bg-lc-gray-100"
      ),
      children: [
        segment("correct-and-explanation", t("toggle.correctAndExplanation"), "bg-lc-mint-900"),
        segment("my-answer", t("toggle.myAnswer"), "bg-lc-lightblue-900")
      ]
    }
  );
}
export {
  QuizResultToggle
};
//# sourceMappingURL=quiz-result-toggle.js.map
